import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/header';
import RouterRender from './router';
import './App.scss';
import { getVersion } from './utils';
import { useEffect, useState } from 'react';

function App() {
  const [version, setVersion] = useState({})
  useEffect(() => {
    getVersion().then(res => {
      setVersion(res)
    })
  }, [])
  return (
    <Router>
      <div className="bodyBox">
        <Header />
        <RouterRender />
        <div className="version">产品版本：{version.version}</div>
      </div>
    </Router>
  );
}

export default App;
